import React, { useEffect, useMemo, useState } from 'react'
import { resolveMediaUrl } from '../../utils/media'
import { PhotoIcon } from '@heroicons/react/24/outline'

interface BlogImageProps {
  src?: string | null
  alt: string
  className?: string
  fallbackClassName?: string
  fallbackText?: string
}

const BlogImage: React.FC<BlogImageProps> = ({
  src,
  alt,
  className,
  fallbackClassName,
  fallbackText = 'Image unavailable',
}) => {
  const resolvedSrc = useMemo(() => resolveMediaUrl(src), [src])
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    setHasError(false)
  }, [resolvedSrc])

  if (!resolvedSrc || hasError) {
    return (
      <div className={fallbackClassName || 'w-full h-full flex flex-col items-center justify-center bg-dark-800 text-gray-500'}>
        <PhotoIcon className="w-8 h-8 mb-2 opacity-50" />
        <span className="text-xs">{fallbackText}</span>
      </div>
    )
  }

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
    />
  )
}

export default BlogImage
